export default {
  SET_ALARM (state, items) {
    state.alarm = items
  },

  CLEAR_ALARM (state) {
    state.alarm.device = ''
    state.alarm.start_time = ''
    state.alarm.end_time = ''
  }
}